
<template>
  <v-app id="sandbox" :dark="dark">
    <v-navigation-drawer
      v-model="primaryDrawer.model"
      :clipped="primaryDrawer.clipped"
      :floating="primaryDrawer.floating"
      :mini-variant="primaryDrawer.mini"
      :permanent="primaryDrawer.type === 'permanent'"
      :temporary="primaryDrawer.type === 'temporary'"
      app
      overflow
    >
      <v-list dense>
        <v-list-item @click="navClick({'name':'dashboard'})">
          <v-list-item-action>
            <v-icon>home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Groups</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navClick({'name':'global_users'})">
          <v-list-item-action>
            <v-icon>contacts</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Organization Users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div v-if="id">
          <v-subheader class="mt-3 grey--text text--darken-1">Group Actions: {{group.name}}</v-subheader>
          <template v-for="item in items">
            <v-layout v-if="item.heading" :key="item.heading" align-center>
              <v-flex xs6>
                <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
              </v-flex>
              <v-flex xs6 class="text-center">
                <a href="#!" class="body-2 black--text">EDIT</a>
              </v-flex>
            </v-layout>
            <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
            >
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item v-for="(child, i) in item.children" :key="i" @click="navClick(child)">
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item v-else :key="item.text" @click="navClick(item)">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="primary" dark :clipped-left="primaryDrawer.clipped" app>
      <v-app-bar-nav-icon
        v-if="primaryDrawer.type !== 'permanent'"
        @click.stop="primaryDrawer.model = !primaryDrawer.model"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>{{name}}</v-toolbar-title>
      <v-spacer />
      <v-menu offset-y left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon  v-on="on">
            <v-icon>person</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item class = "ml-3 mr-3" @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <v-container grid-list-md v-if="group.name!=''">
        <v-layout row wrap>
          <v-card style="width:100%;" class="pb-1">
            <v-card-title>{{group.name}} Dashboard</v-card-title>
          </v-card>
        </v-layout>
      </v-container>
      <router-view />
    </v-content>
    <v-footer :inset="footer.inset" app>
      <span class="px-3">Deka Point Solutions LLC</span>
      <span class="px-3">&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>



<script>
import groupService from "@/services/groups/group";
import userService from "@/services/admin/authorization";
export default {
  props: ["id"],
  data: () => ({
    name: "DEKA Edge",
    items: [
      {
        // icon: "keyboard_arrow_up",

        // "icon-alt": "keyboard_arrow_down",
        icon: "calendar_today",
        text: "Events",
        name: "events",
        params: {}
      },
      // { icon: "comment", text: "Responses", name: "users" },

      { icon: "person", text: "Group Users", name: "users" }
    ],

    dark: false,

    // drawers: ["Default (no property)", "Permanent", "Temporary"],

    primaryDrawer: {
      model: null,

      type: "default (no property)",

      clipped: true,

      floating: false,

      mini: false
    },

    footer: {
      inset: false
    },
    group: { name: "" }
  }),
  methods: {
    navClick(item) {
      this.$router.push({ name: item.name, params: item.params });
    },
    logout(){
      userService.logout()
      .then(data=>{

        this.$router.push({"name":"home"})
      })
      .catch(err=>{
        console.log(err);
      })
    }
  },
  watch: {
    id() {
      if (this.id == undefined || this.id == null) {
        this.group = { name: "" };
      }
      groupService
        .getGroup(this.id)
        .then(group => {
          console.log("Got group", group);
          this.group = group;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    if (this.id == undefined || this.id == null) {
      this.group = { name: "" };
    }
  },
  watch: {
    id() {
      if (this.id == undefined || this.id == null) {
        this.group = { name: "" };
      }
      groupService
        .getGroup(this.id)
        .then(group => {
          console.log("Got group", group);
          this.group = group;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    if (this.id == undefined || this.id == null) {
      this.group = { name: "" };
    }
    groupService
      .getGroup(this.id)
      .then(group => {
        console.log("Got group", group);
        this.group = group;
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>